import { render } from "./TeamProfileCard.vue?vue&type=template&id=770688c3"
import script from "./TeamProfileCard.vue?vue&type=script&lang=js"
export * from "./TeamProfileCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__